import apiService from '../apiService';

const platformUrl = `${window._env_.PLATFORM_API_DOMAIN}`;
const legacyUrl = `${window._env_.LEGACY_APP_REDIRECT_DOMAIN}`;

const getMatches = (entityId) => {
  const url = `${platformUrl}/v1/funding/searches/${entityId}/matches`;
  return apiService.get(url);
};

const cancelMatch = (matchId) => {
  const url = `${legacyUrl}/api/v1/funding/match/${matchId}/cancel`;
  return apiService.put(url);
};

export { getMatches, cancelMatch };
